import { isArray, isBoolean, isDate, isNumber, isString } from 'lodash';
import { Task } from '../store/tasks/types';
import { Language } from '../store/languages/types';

const COUNTRY_KEY_LENGTH = 2;
const TASK_ELEMENT_FEEDBACK = 'feedback';

export const validateLanguages = (dataList: object[], languagesCount: number) => {
    let isValid = true;
    for (let index = 0; index < dataList.length; index++) {
        Object.entries(dataList[index]).every((item) => {
            const value: object = item[1];
            const key = item[0];
            if (key === TASK_ELEMENT_FEEDBACK) {
                Object.entries(value).every((valueItem) => {
                    const feedbackValue = valueItem[1];
                    isValid = checkIsValid(feedbackValue, languagesCount) ?? isValid;
                    return isValid;
                });
            }
            isValid = checkIsValid(value, languagesCount) ?? isValid;
            return isValid;
        });
    }
    return isValid;
};

export const validateUrl = (dataList: Task[], languages: Language[]) => {
    let isValid = true;
    const expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
    const regex = new RegExp(expression);
    dataList.forEach((element) => {
        languages.forEach((lang) => {
            if (element.languageVideoUrl?.[lang.code] !== null && element.languageVideoUrl?.[lang.code]?.match(regex))
                isValid = true;
            else isValid = false;
        });
    });
    return isValid;
};

export const validatePhoneNumber = (input: string) => {
    const pattern = /^\d{9}$/;

    return pattern.test(input);
};

const checkIsValid = (value: object, languagesCount: number) => {
    if (value && !(isString(value) || isArray(value) || isBoolean(value) || isNumber(value) || isDate(value))) {
        let notEmptyCount = 0;
        Object.entries(value).forEach((langVersion) => {
            if (langVersion[0].length === COUNTRY_KEY_LENGTH && langVersion[1]) notEmptyCount += 1;
        });
        if (notEmptyCount > 0 && notEmptyCount < languagesCount) return false;
        return true;
    }
};
